<template>
  <content-page back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">
        Getting Started
      </div>
    </template>
    <div class="pa-2 white" style="font-size: 14px">
      <p>
        Welcome to PartnerLists. Your retail customers will benefit from your recommendations, and we will assist you in building a network of professionals you know and trust. By following the steps below, you'll be making referrals in no time. 
      </p>

      <h3 class="pb-3">Step One: Add your pros</h3>
      <ul>
        <li>
          Tap the <router-link :to="{ name: 'pros/list'}">Pros</router-link> icon on the bottom green navbar.
        </li>
        <li>Tap the green “+”</li>
        <li>Follow the instructions</li>
      </ul>

      <h3 class="py-3">Step Two: Make a referral</h3>
      <ul>
        <li>
          Tap the <router-link :to="{ name: 'referrals'}">Refer</router-link> icon on the bottom green navbar.
        </li>
        <li>Pick the “Service” they are asking for</li>
        <li>Fill in the boxes: name, cell phone number, zip code</li>
        <li>Pick a pro or select multiple, and tap the green “Recommend” button</li>
        <li>Verify the information is correct and tap the green “Confirm” button</li>
      </ul>

      <h3 class="py-3">Step Three: (Optionally) Set up users</h3>
      <ul>
        <li>
          Tap the <router-link :to="{ name: 'you'}">You</router-link> icon on the bottom green navbar.
        </li>
        <li>Tap “Users” menu item</li>
        <li>Tap green ”+”  button in the top right corner</li>
        <li>Follow the instructions</li>
      </ul>

      <p class="pt-3">
        That’s it!  Easy as one, two, three. You can now send your retail customers reliable pros that are ready to work. This will also help you build strong relationships with your current pros.
      </p>
      <p>
        Let us know if you have any additional questions at <a href="mailto:support@partnerlists.com">support@partnerlists.com</a> or you check out the <router-link :to="{ name: 'support' }"> Support</router-link> section of this app.
      </p>
    </div>
  </content-page>
</template>

<script>
  import { ContentPage } from '@/components/pages'

  export default {
    components: { ContentPage, },
  }
</script>

<style lang="scss" scoped>
  .legal {
    font-size: 12px;
    text-align: justify;

    h3 {
      padding-top: .5em;
      padding-bottom: .75em;
      text-align: left;
    }
  }
</style>